import {createRoot, hydrateRoot} from 'react-dom/client';
import Philosophy from '../pages/Philosophy/Philosophy'
import "../index.css";
import "../pages/Philosophy/Philosophy.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<Philosophy {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <Philosophy {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).PhilosophyVC = {mount, hydrate, unmount}